var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F8B3B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99948 10.8161L7.14115 13.6745C7.0342 13.7814 6.89809 13.8349 6.73281 13.8349C6.56753 13.8349 6.43142 13.7814 6.32448 13.6745C6.21753 13.5675 6.16406 13.4314 6.16406 13.2661C6.16406 13.1009 6.21753 12.9648 6.32448 12.8578L9.18281 9.99948L6.32448 7.14115C6.21753 7.0342 6.16406 6.89809 6.16406 6.73281C6.16406 6.56753 6.21753 6.43142 6.32448 6.32448C6.43142 6.21753 6.56753 6.16406 6.73281 6.16406C6.89809 6.16406 7.0342 6.21753 7.14115 6.32448L9.99948 9.18281L12.8578 6.32448C12.9648 6.21753 13.1009 6.16406 13.2661 6.16406C13.4314 6.16406 13.5675 6.21753 13.6745 6.32448C13.7814 6.43142 13.8349 6.56753 13.8349 6.73281C13.8349 6.89809 13.7814 7.0342 13.6745 7.14115L10.8161 9.99948L13.6745 12.8578C13.7814 12.9648 13.8349 13.1009 13.8349 13.2661C13.8349 13.4314 13.7814 13.5675 13.6745 13.6745C13.5675 13.7814 13.4314 13.8349 13.2661 13.8349C13.1009 13.8349 12.9648 13.7814 12.8578 13.6745L9.99948 10.8161Z",
    fill: "#FCFCFC",
    stroke: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a7b23dfe0f71cde1e85a98c575118deb.svg";
export { ForwardRef as ReactComponent };